import { Box, Flex, Heading, Link, Stack, Text } from "@chakra-ui/react";
import type { ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";
import { WizardStepBar } from "./WizardStepBar";
import type { WizardStep } from "./wizardSteps";

interface Props<K extends string> {
  backTo: string;
  backLabel: string;
  title: string;
  subtitle: string;
  headingAside?: ReactNode;
  underSubtitle?: ReactNode;
  steps: ReadonlyArray<WizardStep<K>>;
  currentStep: K;
  stepLabel: (step: K) => string;
  stepShortLabel: (step: K) => string;
  navigateToStep: (step: K) => void;
  children: ReactNode;
}

export const PortalWizardShell = <K extends string>({
  backTo,
  backLabel,
  title,
  subtitle,
  headingAside,
  underSubtitle,
  steps,
  currentStep,
  stepLabel,
  stepShortLabel,
  navigateToStep,
  children,
}: Props<K>) => (
  <Stack spacing="6">
    <Box>
      <Link as={RouterLink} to={backTo} color="smPrimary" fontSize="sm" fontWeight="semibold">
        ← {backLabel}
      </Link>
      <Flex align="center" gap="3" mt="2" flexWrap="wrap">
        <Heading as="h1" size="lg">{title}</Heading>
        {headingAside}
      </Flex>
      <Text color="smMuted" fontSize="sm">
        {subtitle}
      </Text>
      {underSubtitle}
    </Box>

    <WizardStepBar
      steps={steps.map((step) => step.key)}
      currentStep={currentStep}
      navigateToStep={navigateToStep}
      stepLabel={stepLabel}
      stepShortLabel={stepShortLabel}
    />

    <Box minW="0">{children}</Box>
  </Stack>
);
